var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [
    [_c('h3', [_vm._v("Nav")]), _vm._v(" "), _c('div', {
      staticClass: "bs-docs-section"
    }, [_c('div', {
      staticClass: "bs-example"
    }, [_c('n3-nav', {
      attrs: {
        "default-active": _vm.activeIndex,
        "mode": "horizontal"
      },
      on: {
        "select": _vm.handleSelect
      }
    }, [_c('n3-nav-item', {
      attrs: {
        "index": "1"
      }
    }, [_vm._v("Nav one ")]), _vm._v(" "), _c('n3-sub-nav', {
      attrs: {
        "index": "2"
      }
    }, [_c('template', {
      slot: "title"
    }, [_vm._v("Nav two")]), _vm._v(" "), _c('n3-nav-item', {
      attrs: {
        "index": "2-1"
      }
    }, [_vm._v("Item one")]), _vm._v(" "), _c('n3-nav-item', {
      attrs: {
        "index": "2-2"
      }
    }, [_vm._v("Item two")]), _vm._v(" "), _c('n3-nav-item', {
      attrs: {
        "index": "2-3"
      }
    }, [_vm._v("Item three")])], 2), _vm._v(" "), _c('n3-nav-item', {
      attrs: {
        "index": "3"
      }
    }, [_c('a', {
      attrs: {
        "href": "#",
        "target": "_blank"
      }
    }, [_vm._v("Nav three")])])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('n3-nav', {
      style: ({
        width: '180px'
      }),
      attrs: {
        "default-active": "2",
        "theme": "dark"
      },
      on: {
        "open": _vm.handleOpen,
        "close": _vm.handleClose
      }
    }, [_c('n3-sub-nav', {
      attrs: {
        "index": "1"
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('n3-icon', {
      attrs: {
        "type": "bars"
      }
    }), _vm._v("Nav one")], 1), _vm._v(" "), _c('n3-nav-group', {
      key: "1",
      attrs: {
        "title": "Group one"
      }
    }, [_c('template', {
      slot: "title"
    }, [_vm._v("Group one")]), _vm._v(" "), _c('n3-nav-item', {
      key: "1-1",
      attrs: {
        "index": "1-1"
      }
    }, [_vm._v("Item one")]), _vm._v(" "), _c('n3-nav-item', {
      key: "1-2",
      attrs: {
        "index": "1-2"
      }
    }, [_vm._v("Item two")])], 2), _vm._v(" "), _c('n3-nav-group', {
      key: "2",
      attrs: {
        "title": "Group two"
      }
    }, [_c('n3-nav-item', {
      key: "1-2",
      attrs: {
        "index": "1-3"
      }
    }, [_vm._v("Item three")])], 1), _vm._v(" "), _c('n3-sub-nav', {
      attrs: {
        "index": "1-4"
      }
    }, [_c('template', {
      slot: "title"
    }, [_vm._v("Item three")]), _vm._v(" "), _c('n3-nav-item', {
      attrs: {
        "index": "1-4-1"
      }
    }, [_vm._v("Item one")])], 2)], 2), _vm._v(" "), _c('n3-nav-item', {
      attrs: {
        "index": "2"
      }
    }, [_c('n3-icon', {
      attrs: {
        "type": "eye"
      }
    }), _vm._v("Nav two")], 1), _vm._v(" "), _c('n3-nav-item', {
      attrs: {
        "index": "3"
      }
    }, [_c('n3-icon', {
      attrs: {
        "type": "cloud"
      }
    }), _vm._v("Nav three")], 1)], 1)], 1), _vm._v(" "), _c('h3', [_vm._v("n3-nav Params")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h3', [_vm._v("Events")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h3', [_vm._v("n3-sub-nav Params")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h3', [_vm._v("n3-nav-item Params")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h3', [_vm._v("n3-nav-group Params")]), _vm._v(" "), _vm._m(5)])]
  ], 2)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    pre: true
  }, [_c('code', {
    attrs: {
      "v-pre": "",
      "class": "language-html"
    }
  }, [_c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-nav")]), _vm._v("  "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":default-active")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"activeIndex\"")]), _vm._v("  "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("mode")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"horizontal\"")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("@select")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"handleSelect\"")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-nav-item")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("index")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"1\"")]), _vm._v(">")]), _vm._v("Nav one "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-nav-item")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-sub-nav")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("index")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"2\"")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("template")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("slot")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"title\"")]), _vm._v(">")]), _vm._v("Nav two"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("template")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-nav-item")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("index")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"2-1\"")]), _vm._v(">")]), _vm._v("Item one"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-nav-item")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-nav-item")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("index")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"2-2\"")]), _vm._v(">")]), _vm._v("Item two"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-nav-item")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-nav-item")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("index")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"2-3\"")]), _vm._v(">")]), _vm._v("Item three"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-nav-item")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-sub-nav")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-nav-item")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("index")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"3\"")]), _vm._v(">")]), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("a")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("href")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"#\"")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("target")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"_blank\"")]), _vm._v(">")]), _vm._v("Nav three"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("a")]), _vm._v(">")]), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-nav-item")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-nav")]), _vm._v(">")]), _vm._v("\n")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("mode")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("horizontal,vertical")]), _vm._v(" "), _c('td', [_vm._v("vertical")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("theme")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("light,dark")]), _vm._v(" "), _c('td', [_vm._v("light")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("default-active")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("default index")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("default-openeds")]), _vm._v(" "), _c('td', [_vm._v("Array")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("default opened indexs")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("unique-opened")]), _vm._v(" "), _c('td', [_vm._v("Boolean")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("false")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("menu-trigger")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("hover")]), _vm._v(" "), _c('td', [_vm._v("subnav open type(only works when mode is "), _c('code', {
    pre: true
  }, [_vm._v("horizontal")]), _vm._v(")")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("router")]), _vm._v(" "), _c('td', [_vm._v("Boolean")]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_vm._v("vue-router , index as path")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("params")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("select")]), _vm._v(" "), _c('td', [_vm._v("item selected")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("index")]), _vm._v(","), _c('code', {
    pre: true
  }, [_vm._v("indexPath")]), _vm._v(" of selected item")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("open")]), _vm._v(" "), _c('td', [_vm._v("SubMenu open")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("index")]), _vm._v(" ,"), _c('code', {
    pre: true
  }, [_vm._v("indexPath")]), _vm._v(" of opened subMenu")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("close")]), _vm._v(" "), _c('td', [_vm._v("SubMenu close")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("index")]), _vm._v(","), _c('code', {
    pre: true
  }, [_vm._v("indexPath")]), _vm._v(" of closed subMenu")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("index")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td')])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("index")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("route")]), _vm._v(" "), _c('td', [_vm._v("Object")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("Vue Router Object")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("title")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("group")])])])])
}]
render._withStripped = true
export default { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-76059ae0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76059ae0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-markdown-loader/lib/markdown-compiler.js?raw!./docs/example_en/n3NavDocs.md
// module id = 913
// module chunks = 1